import React, { useRef, useState } from "react";
import CareerCard from "../../components/CareerCard";
import PhoneInput from "react-phone-input-2";
import { fetchAPI } from "../../helper/fetchAPI";
import * as constants from "../../constants";
import { t } from "i18next";
import { useSnackbar } from 'notistack';
import CustomImageComponent from "../../components/CustomImageComponent";


const OpeningsSec = (props) => {
  const { Openings } = props
  const [selectedJob, setSelectedJob] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    ApplicantName: '',
    ApplicantPhone: '+20',
    ApplicantEmail: '',
    PositionName: '',
    EmploymentType: '',
    Message: '',
    resumeAttachment: null,
  });

  const { enqueueSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);



  const handleSelectJob = (job) => {
    setSelectedJob(job);  // Store the clicked job in state

    //const name = "PositionName", value = job.title;
    setFormData((prev) => ({
      ...prev,
      PositionName: job.title,
      EmploymentType: job.employmentType || '',
    }));

  };

  const [fileName, setFileName] = useState('No file chosen');

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file ? file.name : 'No file chosen');
    setFormData((prev) => ({
      ...prev,
      resumeAttachment: file,
    }));
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle phone input separately
  const handlePhoneChange = (value) => {

    setFormData((prev) => ({
      ...prev,
      ApplicantPhone: value,
    }));
  };

  const [formErrors, setFormErrors] = useState({});


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const alphaRegex = /^[A-Za-z\s]+$/;

    const errors = {};

    if (!formData.ApplicantName.trim() || !alphaRegex.test(formData.ApplicantName)) {
      errors.ApplicantName = "Name is required";
    }

    if (!formData.PositionName.trim()) {
      errors.PositionName = "Position is required";
    }

    if (!formData.ApplicantEmail.trim()) {
      errors.ApplicantEmail = "Email is required";
    }
    else if (!emailRegex.test(formData.ApplicantEmail)) {
      errors.ApplicantEmail = "Invalid email format";
    }

    if (!formData.ApplicantPhone.trim()) {
      errors.ApplicantPhone = "Phone number is required";
    }

    if (!formData.resumeAttachment) {
      errors.resumeAttachment = "Resume is required";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setIsLoading(false)

      return;
    }


    const form = new FormData();
    form.append('ApplicantName', formData.ApplicantName);
    form.append('ApplicantPhone', formData.ApplicantPhone);
    form.append('ApplicantEmail', formData.ApplicantEmail);
    form.append('PositionName', formData.PositionName);
    form.append('EmploymentType', formData.EmploymentType);
    form.append('Message', formData.Message);

    if (formData.resumeAttachment) {
      form.append('resumeAttachment', formData.resumeAttachment);
    }

    try {

      const res = await fetch(apiUrl + constants.careerapply, {
        method: 'POST',
        body: form,
      });
      if (res.ok) {
        enqueueSnackbar('Application submitted successfully.', { variant: 'success' });
        resetForm()
        const modalEl = document.getElementById('exampleModal');
        const modalInstance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
        modalInstance.hide();

      } else {
        throw new Error('Failed to submit application');
      }
      const result = await res.json();

    } catch (error) {
      console.error('Error:', error);
    }
    setIsLoading(false)
  };

  const resetForm = () => {

    setFormData({
      ApplicantName: '',
      ApplicantPhone: '+20',
      ApplicantEmail: '',
      PositionName: '',
      EmploymentType: '',
      Message: '',
      resumeAttachment: null,
    });
    setFormErrors({});
    setFileName('No file chosen');

    // Clear the actual input element
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }


  return (
    <>
      <section className="company-info-section developer-list-section career-section">
        <div className="container">
          <div className="row">
            {Openings?.map((item, index) => (
              <CareerCard
                key={index}
                cTitle={item.title}
                cOpenings={item.openings || 0}
                cDetails={item.description}
                onClick={() => handleSelectJob(item)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* <!-- Modal --> */}
      <div className="modal fade modal-lg career-modal" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title title" id="exampleModalLabel">{selectedJob?.title || 'N/A'} <span className="opening-text"> {t("openings")} <span>{selectedJob?.openings}</span></span></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <ul className="opening-info">
                <li>
                  {selectedJob?.title || 'N/A'}
                  <p>{selectedJob?.experience || 'N/A'}</p>
                </li>
                <li>{selectedJob?.level || 'N/A'}</li>
                <li>{selectedJob?.department || 'N/A'}</li>
                <li>{selectedJob?.employmentType || 'N/A'}</li>
                <li>{selectedJob?.location || 'N/A'}</li>
              </ul>
              <h4 className="title">{t("apply_now")}</h4>
              <section className="contact-section">
                <div className="form-wrapper">

                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("name")}<span>*</span></label>
                          <input
                            id="Name"
                            type="text"
                            name="ApplicantName"
                            className="form-control"
                            placeholder={t("name_placeholder")}
                            autoComplete="off"
                            value={formData.ApplicantName}
                            onChange={handleChange}
                          />
                          {formErrors.ApplicantName && (
                            <small className="text-danger">{t("name_required")}</small>
                          )}

                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("apply_for")}<span>*</span></label>
                          <input
                            id="position"
                            type="text"
                            name="PositionName"
                            className="form-control"
                            placeholder={t("position_placeholder")}
                            value={formData.PositionName}
                            disabled={true}
                          //onChange={handleChange}
                          />
                          {formErrors.PositionName && (
                            <small className="text-danger">{t("position_required")}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("email")}<span>*</span></label>
                          <input
                            id="email"
                            type="text"
                            name="ApplicantEmail"
                            className="form-control"
                            placeholder={t("email_placeholder")}
                            value={formData.ApplicantEmail}
                            onChange={handleChange}
                          />
                          {formErrors.ApplicantEmail && (
                            <small className="text-danger">{t("email_required")}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("phone")}<span>*</span></label>
                          <PhoneInput
                            id="mobile_number"
                            type="text"
                            name="ApplicantPhone"
                            country={'eg'}
                            //maxLength={17}
                            value={formData.ApplicantPhone}
                            onChange={(value, data, event, formattedValue) => handlePhoneChange(formattedValue)}
                            //onChange={handlePhoneChange}
                            inputClass="w-100  ps-5"
                            placeholder={t("phone_placeholder")}
                            inputProps={{
                              name: 'phone',
                              id: 'mobile_number',
                              autoComplete: 'off',

                            }}
                          />
                          {formErrors.ApplicantPhone && (
                            <small className="text-danger">{t("phone_required")}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("resume")}<span>*</span></label>

                          <div className="input-group input-file-group add_custom_msg">
                            <div className="input-file-group">
                              <input className="form-control" id="uploadFile" type="file" name="resumeAttachment" onChange={handleFileChange} accept=".pdf,.doc,.docx" ref={fileInputRef} />
                              <div className="add_error_msg_sap error"></div>
                              <span className="error-message error"></span>
                            </div>
                          </div>
                          {formErrors.resumeAttachment && (
                            <small className="text-danger">{t("file_required")}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t("message_optional")}</label>
                          <textarea
                            name="Message"
                            placeholder={t("message_placeholder")}
                            className="form-control form-control-textarea"
                            value={formData.Message}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <button type="submit" className="theme-btn theme-btn-secondary" disabled={isLoading}>
                          {isLoading ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (
                            <>
                              {t("submit")}
                              <CustomImageComponent src={"/assets/img/link-arrow.svg"} alt={"link-arrow"} />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
            </div>

          </div>
        </div >
      </div >
    </>
  );
};

export default OpeningsSec;
